<template>
    <div class="invoice">
        <div class="invoice-block"></div>
        <van-cell-group>
            <van-cell is-link v-for="(item, index) in invoiceList" :key="index" @click="toInvocie(item.route)">
                <template #title>
                    <div class="invoice-item flex align-center">
                        <img :src="item.icon" alt="" />
                        <p>{{ item.title }}</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
        <div class="invoice-block"></div>
        <van-cell is-link @click="toInvocie('/invoice/record')">
            <template #title>
                <div class="invoice-item flex align-center">
                    <img src="@/assets/images/invocie/invocie-record.png" alt="" />
                    <p>开票记录</p>
                </div>
            </template>
        </van-cell>

        <div class="text">
            <p class="title">温馨提示</p>
            <p class="container">1、开具电子发票，需要先注册绑定车牌，再进行停车缴费，才能开具发票。</p>
            <p class="container">2、单张开票最高金额不可超过999元，如有需要可开多张。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Invoice",
    data() {
        return {
            invoiceList: [
                // {
                //     icon:require('@/assets/images/invocie/invocie-parking.png'),
                //     title:'充值开票',
                //     route:'/invoice/invoiceRecharge'
                // },
                // {
                //     icon:require('@/assets/images/invocie/invocie-parkingcard.png'),
                //     title:'购买停车卡开票',
                //     route:'/invoice/invoiceParkingCard'
                // },
                {
                    icon: require("@/assets/images/invocie/invocie-parking.png"),
                    title: "停车缴费开票",
                    route: "/invoice/invoiceParking",
                },
                // {
                //     icon:require('@/assets/images/invocie/invocie-record.png'),
                //     title:'开票记录',
                //     route:''
                // }
            ],
        };
    },
    methods: {
        toInvocie(route) {
            this.$router.push(route);
        },
    },
};
</script>

<style lang="less" scoped>
.text {
    min-height: 70px;
    padding: 40px;
    color: #afafaf;
    .title {
        text-align: center;
        margin-bottom: 10px;
    }
    .container {
        margin: 15px 0;
    }
}
.invoice {
    .invoice-block {
        height: 16px;
    }
    .invoice-item {
        img {
            width: 32px;
            height: 32px;
        }
        p {
            font-size: 28px;
            color: #333333;
            margin-left: 17px;
        }
    }
}
</style>
